import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfigState, configFeatureKey } from '../reducers/config.reducer';

export const selectState = createFeatureSelector<ConfigState>(configFeatureKey);
export const selectConfig = createSelector(selectState, state => state.config);
export const selectConfigIsLoading = createSelector(selectState, x => x.isLoading);
export const selectConfigError = createSelector(selectState, x => x.error);
